import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { styled } from '@mui/material/styles';
import { Button, Container, Stack, TextField, Typography } from '@mui/material';

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

export default function LoginEntryPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [locationId, setLocationId] = useState('');

  const handleContinue = () => {
    const normalizedEmail = email.trim().toLowerCase();
    const normalizedLocationId = locationId.trim();
    if (!normalizedEmail || !normalizedLocationId) {
      return;
    }

    navigate(`/login/${encodeURIComponent(normalizedEmail)}?locationId=${encodeURIComponent(normalizedLocationId)}`);
  };

  return (
    <>
      <Helmet>
        <title> Login </title>
      </Helmet>

      <Container>
        <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
          <Typography variant="h3" paragraph>
            Continue to Login
          </Typography>

          <Typography sx={{ color: 'text.secondary', mb: 3 }}>
            Enter your account email and location ID to open the login screen.
          </Typography>

          <Stack spacing={2} sx={{ width: '100%' }}>
            <TextField label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
            <TextField label="Location ID" value={locationId} onChange={(e) => setLocationId(e.target.value)} />
            <Button variant="contained" onClick={handleContinue}>
              Continue
            </Button>
          </Stack>
        </StyledContent>
      </Container>
    </>
  );
}
